import Image from 'next/image'
import styled from 'styled-components'

export const Avatar = styled(Image)`
  border-radius: 50%;
`
